import React, { useRef, useState, useEffect } from 'react';
import './trending.scss'
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Box, Container, Grid, Link } from '@mui/material';
function TrendingPage() {

   const vrShowData = [
  { id: 1, title: "DWARKA BENEATH THE SEA", image: "/assets/trending/sea.webp" },
  { id: 2, title: "VARANASI AFTER SUNSET", image: "/assets/trending/varanasi.webp" },
  { id: 3, title: "KASHI", image: "/assets/trending/varanasi.webp" },
  { id: 4, title: "MANIKARNIKA", image: "/assets/trending/manikarna.webp" },
];

const dData = [
  { id: 1, title: "THE LAST MOMENTS OF LORD KRISHNA", image: "/assets/trending/krishna.webp" },
  { id: 2, title: "JAGANNATH PURI", image: "/assets/trending/jaganath-puri.webp" },
  { id: 3, title: "KEDARNATH", image: "/assets/trending/kedarnath2.webp" },
  { id: 4, title: "BHIM SHILA", image: "/assets/trending/bhimshila.webp" },
  { id: 5, title: "DEOGHAR", image: "/assets/trending/deoghar.webp" },
  { id: 6, title: "VAISHNO DEVI", image: "/assets/trending/vaishno-devi.webp" },
];

const trendingData = [
  { id: 1, number: "1", title: "AYODHYA MANDIR", image: "/assets/trending/somnath.webp" },
  { id: 2, number: "2", title: "DWARKADHISH", image: "/assets/trending/mallikarjuna.webp" },
  { id: 3, number: "3", title: "KEDARNATH", image: "/assets/trending/kedarnath.webp" },
  { id: 4, number: "4", title: "BANARAS", image: "/assets/trending/somnath.webp" },
];

const JyotirlingasData = [
  { id: 1, title: "", image: "/assets/trending/jyoti-coming-soon.webp" },
  { id: 2, title: "", image: "/assets/trending/jyoti-coming-soon.webp" },
  { id: 3, title: "", image: "/assets/trending/jyoti-coming-soon.webp" },
  { id: 4, title: "", image: "/assets/trending/jyoti-coming-soon.webp" },
];

const chardhamData = [
  { id: 1, title: "YAMUNOTRI", image: "/assets/trending/yamunotri.webp" },
  { id: 2, title: "GANGOTRI", image: "/assets/trending/gangotri.webp" },
  { id: 3, title: "KEDARNATH", image: "/assets/trending/kedarnath.webp" },
  { id: 4, title: "BADRINATH", image: "/assets/trending/badrinath.webp" },
];

const chotaChardhamData = [
  { id: 1, title: "BADRINATH", image: "/assets/trending/badrinath.webp" },
  { id: 2, title: "RAMESHWARAM", image: "/assets/trending/rameshwaram.webp" },
  { id: 3, title: "DWARKA", image: "/assets/trending/dwarka.webp" },
  { id: 4, title: "JAGANNATH", image: "/assets/trending/jaganath-puri.webp" },
];

const deviTempleData = [
  { id: 1, title: "", image: "/assets/trending/devi-coming-soon.webp" },
  { id: 2, title: "", image: "/assets/trending/devi-coming-soon.webp" },
  { id: 3, title: "", image: "/assets/trending/devi-coming-soon.webp" },
  { id: 4, title: "", image: "/assets/trending/devi-coming-soon.webp" },
];

const continueWatchingData = [
  { id: 1, title: "Nageshwar", image: "/assets/trending/demo-9.webp" },
  { id: 2, title: "Rameshwaram", image: "/assets/trending/demo-10.webp" },
  { id: 3, title: "Grishneshwar", image: "/assets/trending/demo-11.webp" },
  { id: 4, title: "Omkareshwar", image: "/assets/trending/demo-12.webp" },
];
   return (
      <>
         <Box className="trendingPage" >
            <Container maxWidth="lg">
               <Grid container spacing={2} justifyContent="left" alignItems="center">
                  <Grid size={{ xl: 10, lg: 10, md: 12, sm: 12, xs: 12 }} >
                     <Box className="VrBannerText">
                        <span className="virtualTab">
                           Featured Darshan
                        </span>
                        <div>
                           <h1 className="mt-4">KASHI VISHWANATH</h1>
                           <p>Walk the ancient ghats of Varanasi at dawn. A cinematic journey into the eternal city of light, its aartis, alleys, and the temple at its beating heart.
                           </p>
                           <div className="d-flex gap-3 bannerButton">
                              <Box className="text-center mt-lg-3">
                                 <a href="#formBox" className="btn btn-success text-dark"><i className="fa fa-play ms-1 text-dark"></i> Play </a>
                              </Box>
                              <Box className="text-center mt-lg-3">
                                 <a href="/assets/contest/guideline.pdf" target="_blank" className="btn btn-warning text-dark"><i className="fa fa-arrow-right me-1 text-dark"></i>More Info </a>
                              </Box>
                           </div>
                        </div>
                     </Box>
                  </Grid>
               </Grid>
            </Container>
         </Box>

         <section className="darkTheme">
            <Box className="trendingSection topTrendingSection">
               <Container maxWidth="md">
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">TRENDING NOW</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                      <Swiper
                        className="swiperCitySlider"
                        modules={[Navigation, Pagination, Autoplay]}
                        spaceBetween={20}
                        slidesPerView={4}
                        //  navigation={true}
                        autoplay={{
                           delay: 3000,
                           disableOnInteraction: false,
                        }}
                        breakpoints={{
                           0: {
                              slidesPerView: 2,
                           },
                           576: {
                              slidesPerView: 2,
                           },
                           768: {
                              slidesPerView: 3,
                           },
                           1200: {
                              slidesPerView: 3,
                           },
                        }}
                        >
                        {trendingData.map((item) => (
                           <SwiperSlide key={item.id}>
                              
                              <div className="trendBox">
                              <span className="number">{item.number}</span>

                              <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="content">
                                    <h5>{item.title}</h5>
                                 </div>
                              </div>
                              </div>
                              
                           </SwiperSlide>
                        ))}
                        </Swiper>
                     </Grid>
                  </Grid>
               </Container>
            </Box>
            <Box className="trendingSection">
               <Container maxWidth="lg">
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">360 VR Shows</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {vrShowData.map((item) => (
                              <SwiperSlide key={item.id}>
                                    
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>


                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">180 VR Experience</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {dData.map((item) => (
                              <SwiperSlide key={item.id}>
                                
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                                 
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>
                  
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">12 Jyotirlingas</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {JyotirlingasData.map((item) => (
                              <SwiperSlide key={item.id}>
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>
                  
                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">CHAR DHAM YATRA</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                        <Swiper
                              className="swiperCitySlider"
                              modules={[Navigation, Pagination, Autoplay]}
                              spaceBetween={20}
                              slidesPerView={4}
                              autoplay={{
                                 delay: 3000,
                                 disableOnInteraction: false,
                              }}
                              breakpoints={{
                                 0: {
                                    slidesPerView: 2,
                                 },
                                 576: {
                                    slidesPerView: 2,
                                 },
                                 768: {
                                    slidesPerView: 4,
                                 },
                                 1200: {
                                    slidesPerView: 4,
                                 },
                              }}
                              >
                              {chardhamData.map((item) => (
                                 <SwiperSlide key={item.id}>
                                    <div className="templeCard">
                                    <img src={item.image} alt={item.title} />

                                    <div className="overlay"></div>

                                    <div className="cardContent">
                                       <h5>{item.title}</h5>

                                       <button>PLAY NOW</button>
                                    </div>
                                    </div>
                                 </SwiperSlide>
                              ))}
                              </Swiper>
                     </Grid>
                  </Grid>



                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">CHOTA CHAR DHAM YATRA</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                        <Swiper
                              className="swiperCitySlider"
                              modules={[Navigation, Pagination, Autoplay]}
                              spaceBetween={20}
                              slidesPerView={4}
                              autoplay={{
                                 delay: 3000,
                                 disableOnInteraction: false,
                              }}
                              breakpoints={{
                                 0: {
                                    slidesPerView: 2,
                                 },
                                 576: {
                                    slidesPerView: 2,
                                 },
                                 768: {
                                    slidesPerView: 4,
                                 },
                                 1200: {
                                    slidesPerView: 4,
                                 },
                              }}
                              >
                              {chotaChardhamData.map((item) => (
                                 <SwiperSlide key={item.id}>
                                    <div className="templeCard">
                                    <img src={item.image} alt={item.title} />

                                    <div className="overlay"></div>

                                    <div className="cardContent">
                                       <h5>{item.title}</h5>

                                       <button>PLAY NOW</button>
                                    </div>
                                    </div>
                                 </SwiperSlide>
                              ))}
                              </Swiper>
                     </Grid>
                  </Grid>


                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">SHAKTI PEETHAS & DEVI TEMPLES</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                       <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {deviTempleData.map((item) => (
                              <SwiperSlide key={item.id}>
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>


                  <Grid container spacing={2} alignItems="stretch">
                     <Grid size={12}>
                        <Grid container spacing={2} alignItems="stretch">
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div className="templeInnerHeading">
                                 <h2 className="text-start text-white">CONTINUE WATCHING</h2>
                              </div>
                           </Grid>
                           <Grid size={{ xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }} >
                              <div class="text-lg-end">
                                 <a href="/trending-detail/" class="seeBtn">
                                    See All
                                    <i class="fa fa-arrow-right ms-2"></i>
                                 </a>
                              </div>
                           </Grid>
                        </Grid>
                     </Grid>
                     <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
                        <Swiper
                           className="swiperCitySlider"
                           modules={[Navigation, Pagination, Autoplay]}
                           spaceBetween={20}
                           slidesPerView={4}
                           autoplay={{
                              delay: 3000,
                              disableOnInteraction: false,
                           }}
                           breakpoints={{
                              0: {
                                 slidesPerView: 2,
                              },
                              576: {
                                 slidesPerView: 2,
                              },
                              768: {
                                 slidesPerView: 4,
                              },
                              1200: {
                                 slidesPerView: 4,
                              },
                           }}
                           >
                           {continueWatchingData.map((item) => (
                              <SwiperSlide key={item.id}>
                                
                                 <div className="templeCard">
                                 <img src={item.image} alt={item.title} />

                                 <div className="overlay"></div>

                                 <div className="cardContent">
                                    <h5>{item.title}</h5>

                                    <button>PLAY NOW</button>
                                 </div>
                                 </div>
                                 
                              </SwiperSlide>
                           ))}
                           </Swiper>
                     </Grid>
                  </Grid>
               </Container>
            </Box>
         </section>
      </>
   );
}
export default TrendingPage;